/**
 * Check if two given dates have the same time (hours/minutes)
 */
export default function isSameTime(a, b) {
  return a.getHours() === b.getHours() && a.getMinutes() === b.getMinutes();
}
